import { z } from 'zod';

import { createEnv } from './create-env';

export function keys() {
  return createEnv({
    server: {
      // to detect if we're in CI environment, where we want to avoid using real secrets
      CI: z.stringbool().optional(),
      GITHUB_ACTIONS: z.stringbool().optional(),

      NODE_ENV: z.enum(['development', 'production', 'test']).default('development'),

      LOG_LEVEL: z.enum(['trace', 'debug', 'info', 'warning', 'error', 'fatal']).optional(),

      AZURE_TENANT_ID: z.string().min(1).default('temp'),
      AZURE_CLIENT_ID: z.string().min(1).default('temp'), // only set in prod (managed identity)
      AZURE_SUBSCRIPTION_ID: z.string().min(1).default('temp'),

      WAYKITE_SECRET_KEY: z.string().min(1).optional(),
    },
  });
}
